import { useMutation } from '@tanstack/react-query';
import { fetchWithHeaders } from '@sendible/common';
import endpoints from '../../data-layer/endpoints';

const { RequestWorkspaceAccess } = endpoints;

interface WorkspaceAccessRequestResult {
  sent: boolean;
}

/**
 * Rendered before the app shell (and its shared-state bridge) has finished initialising, so the
 * access token is passed in explicitly rather than read via useBridgeContext.
 */
export const useRequestWorkspaceAccess = (accessToken?: string) => {
  const { method, endpoint } = RequestWorkspaceAccess;

  return useMutation({
    mutationFn: async () =>
      fetchWithHeaders({
        method,
        url: endpoint,
        params: { access_token: accessToken },
      }) as Promise<WorkspaceAccessRequestResult>,
  });
};
